import { Injectable } from '@angular/core';
import {HttpClient, HttpParams} from "@angular/common/http";
import {Sort} from "../models/sort";
import {SortHelper} from "../utils/sort-helper";
import {PageResponse} from "../models/page-response";
import {Tag} from "../models/tag";
import {environment} from "../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class TagService {

  constructor(private httpClient: HttpClient) { }

  list(page: number, sort?: Sort, filters: HttpParams = new HttpParams()) {
    let params = filters.set('page', page.toString());

    if (sort) {
      params = params.set('sort', SortHelper.convertSortToString(sort));
    }

    return this.httpClient.get<PageResponse<Tag>>(`${environment.api}/api/v1/tags`, {
      params,
    });
  }

  detail(id: number) {
    return this.httpClient.get<Tag>(`${environment.api}/api/v1/tags/${id}`);
  }

  delete(tag: Tag) {
    return this.httpClient.delete(`${environment.api}/api/v1/tags/${tag.id}`);
  }

  create(tag: Tag, icon: string | Blob | null) {
    const formData = new FormData();

    // Create 'input' json part
    formData.append('input', new Blob([JSON.stringify(tag)], { type: 'application/json' }));

    if (icon) {
      // Create 'icon' file part
      formData.append('icon', icon);
    }

    return this.httpClient.post<Tag>(`${environment.api}/api/v1/tags`, formData);
  }

  update(tag: Tag, icon: string | Blob | null) {
    const formData = new FormData();

    // Create 'input' json part
    formData.append('input', new Blob([JSON.stringify(tag)], { type: 'application/json' }));

    if (icon) {
      // Create 'icon' file part
      formData.append('icon', icon);
    }

    return this.httpClient.put<Tag>(`${environment.api}/api/v1/tags/${tag.id}`, formData);
  }

  icon(entity: Tag) {
    return this.httpClient.get(`${environment.api}/api/v1/tags/${entity.id}/icon`, {
      responseType: 'blob',
    });
  }
}
